import React from 'react';
import SectionCard from './SectionCard';
import { RadioGroup, RadioGroupItem } from '../../../components/ui/radio-group';
import { Checkbox } from '../../../components/ui/checkbox';

const SendToSection = ({ submission, jsonContent, isDark, getSendingOptionText }) => {
    if (submission.recipient_source === 'non-strata') {
        return null;
    }

    return (
        <>
            <SectionCard isDark={isDark}>
                <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                    isDark ? 'text-white' : 'text-[#072837]'
                }`}>Send to: <span className='text-red-500'>*</span></p>
                <RadioGroup value={submission.sendTo}>
                    <div className='flex flex-col gap-[14px]'>
                        <div className='flex gap-[8px] items-center'>
                            <RadioGroupItem value={submission.sendTo} id="sendTo-selected" />
                            <label htmlFor="sendTo-selected" className={`text-[16px] m-0 cursor-default text-capitalize transition-colors duration-200 ${
                                isDark ? 'text-white' : 'text-[#072837]'
                            }`}>{getSendingOptionText().replace(/_/g, ' ')}</label>
                        </div>
                    </div>
                </RadioGroup>
            </SectionCard>

            {/* Send To - Lot Only Sections */}
            {submission.sendTo == 'lotOnly' && (
                <>
                    <SectionCard isDark={isDark}>
                        <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                            isDark ? 'text-white' : 'text-[#072837]'
                        }`}>Lots user type</p>
                        <div className='flex flex-col gap-[14px]'>
                            {submission.lotsUserTypes.split(',').map((type, index) => (
                                <div key={index} className='flex gap-[8px] items-center'>
                                    <Checkbox
                                        id={`lotsUserType-${index}`}
                                        checked={true}
                                        labelClassName="cursor-default"
                                        isDark={isDark}
                                    />
                                    <label htmlFor={`lotsUserType-${index}`} className={`text-[16px] m-0 cursor-default text-capitalize transition-colors duration-200 ${
                                        isDark ? 'text-white' : 'text-[#072837]'
                                    }`}>{type.trim()}</label>
                                </div>
                            ))}
                        </div>
                    </SectionCard>
                    <SectionCard isDark={isDark}>
                        <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                            isDark ? 'text-white' : 'text-[#072837]'
                        }`}>Lot #</p>
                        <div>
                            <input 
                                className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                                    isDark 
                                        ? 'bg-[#161515]  text-white' 
                                        : 'bg-[#f5f5f5] text-[#072837]'
                                }`} 
                                type="text" 
                                value={submission.lotNumber || jsonContent.lotNumber || ''} 
                                readOnly 
                            />
                        </div>
                        <p className={`m-0 text-[12px] transition-colors duration-200 ${
                            isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
                        }`}>Add multiple Lots and who to.</p>
                    </SectionCard>
                </>
            )}
        </>
    );
};

export default SendToSection;
